module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/connect-d2f9bad035ee5c51afd5c1c1d6472374.png";